import { get, post, put } from './http';
// 公共组件代码
//登录
export const login = p => post(`/msdata/login`, p); //注册检查输入的图形验证码
export const listWithRegisteredUser = p => get(`/msdata/school/listWithRegisteredUser`, p); //获取已被注册用户的学校列表（登录时）
export const getSchoolById = p => get(`/msdata/school/${p}`); //获取学校id获取学校名称
export const loginOut = p => post(`/msdata/logout`, p);   //退出登录

//注册
export const getProvince = p => get(`/msdata/province`, p); //获取省份数据
export const getCity = p => get(`/msdata/city/${p}`);  //获取省份数据
export const getSchool = p => get(`/msdata/school/list/${p}`); //获取省份数据
export const checkAndSendSMS = p => get(`/msdata/verifyCode/checkAndSendSMS/${p}`);//注册检查输入的图形验证码
export const forgetPassword = (p, q) => post(`/msdata/sysUser/forgetPassword/${p}`, q);  //忘记密码，修改密码
export const register = p => post(`/msdata/sysUser/register`, p);   //注册
export const getImage = p => get(`/msdata/verifyCode/getImage`, p);   //获取图形验证码

//用户管理
export const getInfo = p => get(`/msdata/sysUser/info`, p);     //获取个人信息
export const listWithKeyword = p => get(`/msdata/school/listWithKeyword`, p); //获取已被注册用户的学校列表（登录时）
export const checkOldPassword = p => post(`/msdata/sysUser/updatePhone/checkOldPassword`, p);   //绑定手机，确认密码
export const bindOrUpdatePhone = p => put(`/msdata/sysUser/updatePhone/bindOrUpdatePhone/${p}`);   //绑定手机/换绑手机
export const updatePassword = p => put(`/msdata/sysUser/updatePassword`, p);    //个人信息设置修改密码
export const updateUser = p => put(`/msdata/sysUser/update`, p);    //修改用户信息
export const updateDefaultPwd = p => put(`/msdata/sysUser/updateDefaultPwd`, p);     //如果是默认密码则重置

//非公共组件
//登录注册
// export const login = p => post(`/msdata/auth/login`,p);//登录
// export const register = p => post(`/msdata/auth/register`,p);//注册
export const sendRegCodeByPhone = p => get(`/msdata/auth/sendRegCodeByPhone`, p);//获取注册手机验证码
export const sendRetCodeByPhone = p => get(`/msdata/auth/sendRetCodeByPhone`, p);//获取忘记密码手机验证码
export const checkRetPhoneCode = p => get(`/msdata/auth/checkRetPhoneCode`, p);//忘记密码:判断短信验证码是否输入正确
export const querySchool = p => get(`/msdata/auth/querySchool`, p);//获取学校信息
export const retrieve = p => post(`/msdata/auth/retrieve`, p);//根据电话号码修改密码

//数据资源
export const queryResource = p => get(`/msdata/data/resource/queryResource`, p);//获取数据资源列表
export const publicDetail = p => get(`/msdata/data/resource/publicDetail`, p);//获取数据资源列表
export const giveLike = p => get(`/msdata/data/resource/giveLike`, p);//给数据资源点赞
export const queryResourceMenu = p => get(`/msdata/data/resource/liveDetail`, p);//查看数据资源目录
export const resourceMenu = p => get(`/msdata/data/resource/menu`, p);//获取数据资源目录

//个人信息
export const addFavorites = p => post(`/msdata/favorites/addFavorites`, p);//添加收藏夹
export const addResourceToFavorites = p => post(`/msdata/favorites/addResourceToFavorites`, p);//将资源添加到文件夹
export const deleteFavorites = p => post(`/msdata/favorites/deleteFavorites`, p);//删除收藏夹
export const queryFavorites = p => get(`/msdata/favorites/queryFavorites`, p);//收藏夹列表
export const queryResourceInFavorites = p => get(`/msdata/favorites/queryResourceInFavorites`, p);//查看收藏夹中的资源列表
export const classAssignment = p => get(`/msdata/assignment/student/classAssignment`, p);//获取班级任务
export const getAssignment = p => get(`/msdata/assignment/student/assignmentDetail`, p);//查看班级任务详情
export const getUserInfo = p => get(`/msdata/user/info/getUserInfo`, p);//获取用户信息
export const getAnnouncement = p => get(`/msdata/notice/getAnnouncement`, p);//获取更新公告
export const queryFavoritesWithResourceId = p => get(`/msdata/favorites/queryFavoritesWithResourceId`, p);//收藏数据资源：收藏夹列表(会返回资源是否在该收藏夹中)
export const removeResource = p => post(`/msdata/favorites/removeResource`, p);//取消收藏，将资源移出收藏夹
export const updateFavorites = p => post(`/msdata/favorites/updateFavorites`, p);//我的收藏夹，编辑收藏夹
export const changeAvatar = p => post(`/msdata/user/info/changeAvatar`, p);//更换用户头像
// export const updatePassword = p => post(`/msdata/user/info/updatePassword`,p);//根据旧密码修改密码
export const updateUserInfo = p => post(`/msdata/user/info/updateUserInfo`, p);//个人中心更改个人信息

//案例分析
export const addPageView = p => post(`/msdata/caseAnalysis/addPageView`, p);//增加浏览量
export const caseGiveLike = p => post(`/msdata/caseAnalysis/giveLike`, p);//给案例分析点赞/取消
export const queryCaseAnalysis = p => get(`/msdata/caseAnalysis/queryCaseAnalysis`, p);//案例分析列表
export const queryCaseCategory = p => get(`/msdata/caseAnalysis/queryCaseCategory`, p);//行业分类

//通知信息
export const queryNotice = p => get(`/msdata/notice/queryNotice`, p);//获取通知列表
export const setIsRead = p => post(`/msdata/notice/setIsRead`, p);//将信息设为已读
export const deleteNotice = p => post(`/msdata/notice/deleteNotice`, p);//删除消息

//云课堂相关接口
export const articleSubject = p => get(`/msdata/cloud/article/subject`, p);//获取云课堂专题文章的几个专题
export const articlePublisher = p => get(`/msdata/cloud/article/publisher`, p);//文章发布者列表（发布单位）
export const articleList = p => post(`/msdata/cloud/article/list`, p);//专题多个文章列表
export const articleDetail = p => get(`/msdata/cloud/article/detail`, p);//查询文章详情
export const articleCollection = p => get(`/msdata/cloud/article/collection`, p);//获取云课堂专题文章的列表
export const cloudVideo = p => get(`/msdata/cloud/video`, p);//教学视频列表

//社区接口
export const communityDetail = p => get(`/msdata/community/detail`, p);//数据详细信息
export const communitySearch = p => post(`/msdata/community/search`, p);//搜索
export const insertShareFile = p => post(`/msdata/community/add`, p);//添加共享文件
export const sourceDataFile = p => get(`/msdata/common/getFile`, p);//获取公共社区与数据资源公共数据下载的文件
// export const sourceDataFileTwo = p => get(`/msdata/data/resource/sourceDataFile`,p);//数据资源进入公共数据下载
export const field = p => get(`/msdata/community/public/field`, p);//获取公共社区领域

//云实验室
export const cloudList = p => get(`/msdata/cloudlab/list`, p);//获取云实验室列表
export const menu = p => get(`/msdata/cloudlab/menu`, p);//获取云实验室导航栏数据
export const detailList = p => get(`/msdata/cloudlab/detailList`, p);//基于云实验子目录筛选数据

//案例管理与公共数据上传
export const insertCase = p => post(`/msdata/caseAnalysis/add`, p);//添加案例
export const uploadPublicFile = p => post(`/msdata/common/file`, p);//公共数据上传文件
export const insertPublicData = p => post(`/msdata/data/resource/public/add`, p);//添加公共数据
export const getPublicMenu = p => get(`/msdata/data/resource/public/menu`, p);//获取公共数据目录
export const uploadPublicTemplate = p => post(`/msdata/data/resource/uploadTemplate`, p);//上传公共数据模板

//课件管理
export const courseDetail = p => get(`/msdata/student/courseware/detail?coursewareId=${p}`);//获取课程列表细节
export const courseList = p => get(`/msdata/student/courseware/list`, p);//获取课程目录

//智能测评
export const exportSurvey = p => get(`/msdata/survey/report/export`, p);//导出用户提交的问卷
export const surveyList = p => get(`/msdata/survey/student/list`, p);//学生端测评列表
export const writeSurvey = p => post(`/msdata/survey/submit`, p);//填写问卷
export const previewSurvey = p => get(`/msdata/survey/preview`, p);//预览问卷(查看问卷题目)

//竞赛与任务
export const getCompetitionList = params => get('/msdata/competition/user/list', params); //获取可参与的竞赛列表
export const getCompetitionInfo = competitionId => get(`/msdata/competition/info/${competitionId}`); //获取竞赛详情
export const signUp = (competitionId, params) => post(`/msdata/competition/signUp/${competitionId}`, params); //报名竞赛
export const uploadDataFile = params => post('/msdata/common/dataFile?fileType=COMPETITION_FILE', params); //上传数据文件（上传竞赛文件）
export const submitFile = (competitionId, file) => post(`/msdata/competition/submitFile/${competitionId}`, file); //提交竞赛文件
export const getSubmittedFileList = competitionId => get(`/msdata/competition/getSubmittedFileList/${competitionId}`); //获取提交的竞赛文件列表

// 拿到token
// export const getUserInfo = p => get('/sysUser/info',p);//个人信息


/**
 *
 * 数据资源
 */
//数据预览
export const dataPreview = (url, p) => get(url, p);//预览

// 股票数据
export const getStockMenu = p => get('/ms_resource/stock/menu', p);//左侧列表
export const getStockdetail = p => get('/ms_resource/stock/detail', p);//数据
export const getStocksearch = p => get('/ms_resource/stock/search', p);//查询
export const getStockExcel = p => post('/ms_resource/stock/export', p);//下载
export const stockPreviewApi = p => get('/ms_resource/stock/preview', p);//预览

// 期货数据
export const futuresMenu = p => get('/ms_resource/futures/menu', p);//左侧列表
export const futuresDetail = p => get('/ms_resource/futures/detail', p);//数据
export const futuresSearch = p => get('/ms_resource/futures/search', p);//查询
export const futuresExcel = p => get('/ms_resource/futures/export', p);//下载

// 宏观数据
export const macro = p => get('/ms_resource/macro/interface-list', p); //宏观数据列表
export const macroMenu = p => get('/ms_resource/macro/menu', p); //宏观数据目录
export const priceExample = p => get('/ms_resource/macro/example', p); //宏观数据目录
export const priceDataFile = p => get('/ms_resource/macro/download', p); //宏观数据目录

// 外汇数据
export const foreignMenu = p => get('/ms_resource/fc/menu', p); //外汇数据目录
export const foreignDownload = p => get('/ms_resource/fc/download', p); //外汇数据下载

// 能源目录
export const energyMenu = p => get('/ms_resource/energy/menu', p); //能源数据目录
export const energyCity = p => get('/ms_resource/energy/city', p); //能源城市列表
export const provideDate = p => get('/ms_resource/energy/date', p); //选择调整日期

// 另类数据
export const otherMenu = p => get('/ms_resource/alternative/menu', p); //另类数据目录
export const otherSubMenu = p => get('/ms_resource/alternative/data-type', p); //另类数据子目录
export const provinceOrCity = p => get('/ms_resource/alternative/city', p); //空气质量选择城市，未传省份则返回省份，否则返回城市

// 期权数据
export const optionMenu = p => get('/ms_resource/option/menu', p); //期权数据目录
export const optionSubMenu = p => get('/ms_resource/option/data-type', p); //期权数据子目录
export const contractCode = p => get('/ms_resource/option/contract-code', p); //获取合约代码

//科研合作
export const researchMenu = p => get('/ms_resource/rc/menu',p);//科研数据列表

// 财务数据
export const financeMenu = p => get('/ms_resource/finance/menu',p);// 获取左侧目录





//文件下载
export const downloadFile = (fileName, fileUrl) => {
    const a = document.createElement('a');
    a.href = fileUrl;
    if (fileName) {
        a.download = fileName;
    }
    a.target = '_blank';
    a.click();
    a.remove();
}


/**
 * 动态数据看板
 * */
export const getTheFullMacroApi = p => post('/ms_resource/dynamic/macro/list/'+p);// 获取全部宏观信息
export const getAListOfStocksApi = p => get('/ms_resource/dynamic/list/'+p);// 根据股票代码或股票名称筛选股票列表
export const getMinuteDataApi = p => post('/ms_resource/dynamic/realTimeData/'+p);// 获取指定股票代码的分钟数据
